import { useCallback } from 'react'

import useSWR from 'swr'

import { MeetingsAPI } from 'api/index'
import { MeetingTypeDict, MeetingTypeWithId } from 'types/MeetingType'

const fetcher = (url: string) => MeetingsAPI.get(url).then((res) => res.data)

export default function useCustomMeetingTypes() {
  const { data, error, isLoading, mutate } = useSWR<MeetingTypeDict>(
    '/scheduling/settings/custom/v2',
    fetcher
  )

  const onDelete = useCallback(
    async (meeting: MeetingTypeWithId) => {
      const mutatedData = structuredClone(data) as typeof data
      mutatedData && delete mutatedData[meeting.id]

      mutate(mutatedData, false)
      await MeetingsAPI.delete(`/scheduling/settings/custom/${meeting.id}`)
      mutate()
    },
    [mutate, data]
  )
  return {
    meetingTypes: data,
    isLoading: isLoading || error,
    isError: error,
    onDelete,
  }
}
